import { UpdateConfigForm } from 'components/forms/UpdateConfigForm';
import { IPrices } from 'models/prices.model';
import { userStore } from 'stores';

export const Prices = () => {
	return (
		<>
			{Object.entries(userStore?.prices || {})?.map(([key, price]) => (
				<UpdateConfigForm key={key} price={price} id={key as keyof IPrices} />
			))}
		</>
	);
};
